if (!customElements.get('sound-sample-player')) {
  customElements.define(
    'sound-sample-player',
    class SoundSamplePlayer extends HTMLElement {
      connectedCallback() {
        this.audio = this.querySelector('.sound-sample__audio');
        this.toggle = this.querySelector('.sound-sample__toggle');
        this.playIcon = this.querySelector('.sound-sample__icon--play');
        this.pauseIcon = this.querySelector('.sound-sample__icon--pause');
        this.track = this.querySelector('.sound-sample__track');
        this.progress = this.querySelector('.sound-sample__progress');
        this.handle = this.querySelector('.sound-sample__handle');
        this.currentTimeEl = this.querySelector('.sound-sample__time-current');
        this.durationEl = this.querySelector('.sound-sample__time-duration');

        this.toggle.addEventListener('click', () => this.togglePlayback());
        this.audio.addEventListener('play', () => this.setPlayingState(true));
        this.audio.addEventListener('pause', () => this.setPlayingState(false));
        this.audio.addEventListener('timeupdate', () => this.updateProgress());
        this.audio.addEventListener('loadedmetadata', () => this.updateDuration());
        this.audio.addEventListener('ended', () => this.reset());
        this.track.addEventListener('click', (event) => this.seek(event));
        this.track.addEventListener('keydown', (event) => this.handleKeydown(event));

        if (this.audio.readyState >= 1) this.updateDuration();
      }

      togglePlayback() {
        if (this.audio.paused) {
          this.audio.play()?.catch((error) => {
            console.error('Klangprobe konnte nicht abgespielt werden:', error);
          });
        } else {
          this.audio.pause();
        }
      }

      setPlayingState(isPlaying) {
        this.playIcon.hidden = isPlaying;
        this.pauseIcon.hidden = !isPlaying;
        this.toggle.setAttribute(
          'aria-label',
          isPlaying ? this.toggle.dataset.pauseLabel : this.toggle.dataset.playLabel
        );
      }

      updateProgress() {
        if (!this.audio.duration) return;
        const ratio = this.audio.currentTime / this.audio.duration;
        this.progress.style.width = `${ratio * 100}%`;
        this.handle.style.left = `${ratio * 100}%`;
        this.track.setAttribute('aria-valuenow', Math.round(ratio * 100));
        this.currentTimeEl.textContent = this.formatTime(this.audio.currentTime);
      }

      updateDuration() {
        this.durationEl.textContent = this.formatTime(this.audio.duration);
      }

      seek(event) {
        if (!this.audio.duration) return;
        const rect = this.track.getBoundingClientRect();
        const ratio = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1);
        this.audio.currentTime = ratio * this.audio.duration;
      }

      handleKeydown(event) {
        if (!this.audio.duration) return;
        if (event.key === 'ArrowRight') {
          this.audio.currentTime = Math.min(this.audio.currentTime + 5, this.audio.duration);
        } else if (event.key === 'ArrowLeft') {
          this.audio.currentTime = Math.max(this.audio.currentTime - 5, 0);
        } else {
          return;
        }
        event.preventDefault();
      }

      reset() {
        this.audio.currentTime = 0;
      }

      formatTime(seconds) {
        if (!isFinite(seconds)) return '–:--';
        const minutes = Math.floor(seconds / 60);
        const remainder = Math.floor(seconds % 60)
          .toString()
          .padStart(2, '0');
        return `${minutes}:${remainder}`;
      }
    }
  );
}
